import { AppState } from '../../app/state/AppState';
import { changeDataAccelerationTaskSchedule } from '../../app/actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { currentUserIsAdmin } from '../../app/utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { IAccelerationTaskInfo } from '../../ts/models/IAccelerationTaskInfo';
import { IDatasourceActions } from '../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../ts/ServerApi/types/IWorkbookActions';
import { Messages } from '../../codegen/Localize';
import { selectSpaceInfoItem } from '../../app/selectors/SpaceInfoSelectors';

export const ChangeDataAccelerationScheduleEntityAction:
    IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeFrequency_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: changeDataAccelerationTaskSchedule
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return currentUserIsAdmin(state);
}
